import { render, staticRenderFns } from "./PersonDocuments.vue?vue&type=template&id=d4810fd6&scoped=true&"
import script from "./PersonDocuments.vue?vue&type=script&lang=ts&"
export * from "./PersonDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4810fd6",
  null
  
)

export default component.exports